export default "__VITE_ASSET__BuEoFIMQ__"